var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6666 9.33333C27.6666 9.88561 27.2189 10.3333 26.6666 10.3333L5.33329 10.3333C4.78101 10.3333 4.33329 9.88561 4.33329 9.33333C4.33329 8.78104 4.78101 8.33333 5.33329 8.33333L26.6666 8.33333C27.2189 8.33333 27.6666 8.78104 27.6666 9.33333Z",
    fill: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6666 16C27.6666 16.5523 27.2189 17 26.6666 17L5.33329 17C4.78101 17 4.33329 16.5523 4.33329 16C4.33329 15.4477 4.78101 15 5.33329 15L26.6666 15C27.2189 15 27.6666 15.4477 27.6666 16Z",
    fill: "#1C274C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6666 22.6667C27.6666 23.2189 27.2189 23.6667 26.6666 23.6667L5.33329 23.6667C4.78101 23.6667 4.33329 23.2189 4.33329 22.6667C4.33329 22.1144 4.78101 21.6667 5.33329 21.6667L26.6666 21.6667C27.2189 21.6667 27.6666 22.1144 27.6666 22.6667Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.a0e4aac1b59b0434c4340747987cbec0.svg";
export { ForwardRef as ReactComponent };